import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { ChildClient } from "../../parentApi";

export default new ChildClient(app_uri, axiosClient());
